import { addDays,isValid } from 'date-fns';
import { fromUnixTime } from 'date-fns/esm';
import format from 'date-fns/format'


export class DateUtility {
    static dateToString = (date,formatStr = "MM/dd/yyyy") => {
        if (!date) return '';
        if (isValid(date)) {
            return format(date,formatStr);
        }
        return '';
    }

    static msToDate = (ms) => {
        return fromUnixTime(ms);
    }

    static addDay = (date,day) => {
        return addDays(date,day);
    }

}